/**
 * Screens that come from the APPROVED REDESIGN DOCUMENT rather than from the
 * launch workbook's Screen Contract sheet.
 *
 * WHY THIS FILE EXISTS. There are two approved design artefacts and they are
 * not the same document:
 *
 *   1. documentation/management-portal-launch/
 *      SecureEmbed_Management_Portal_Implementation_Launch_Control_Workbook.xlsx
 *      sheet 'Screen Contract' — 143 rows, one line of prose each. This is
 *      what screenContract.generated.ts is generated from.
 *   2. documentation/SecureEmbed_Management_Portal_Redesign_and_Environment_
 *      Control_Plane_Plan.docx — the redesign Rob approved, carrying eleven
 *      MOCKUP IMAGES of what the screens actually look like.
 *
 * The workbook is a checklist; the document is the design. Where the document
 * shows a screen the workbook has no row for, that screen is still approved,
 * and the shared chrome has to be able to title it, place it in a tab strip
 * and describe it — which it can only do from a contract row. Rows here fill
 * exactly that gap. They are hand-written because their source is a Word
 * document with pictures in it, not a spreadsheet a generator can read.
 *
 * This is NOT a place to invent screens. Every row must name the mockup image
 * it came from. The generated contract is never edited to add one, for the
 * same reason scopeDecisions.tsx records withdrawals rather than deleting
 * rows: the approved artefacts stay intact and the deltas are legible.
 */
import type { ScreenContract } from './screenContract.generated';

export const DESIGN_DOC_SCREENS: readonly ScreenContract[] = [
  {
    // Mockup 1 (word/media/image2.png) — "Platform Overview". Home's landing
    // screen: four live stat cards, a staleness banner, recent operations,
    // environments and alerts. The workbook has no row for it; its H01
    // "Attention" is the exception list, which the document shows as a
    // SIBLING TAB, not as the landing screen.
    id: 'H00',
    lhs: 'Home',
    group: 'Exception-first estate home',
    tab: 'Overview',
    route: '/home[?view=overview][&environmentId={environmentId}&portalId={portalId}]',
    navPosition: 'LHS Home → Overview (the landing screen)',
    focus:
      'The environment chosen in the global selector. Every card is refetched against that environment; the environments and alerts panels are deliberately estate-wide so the environment you are NOT looking at stays visible.',
    owner:
      'Health API, environment status endpoint, ingestion jobs API, Cost Explorer via the costs API, the environment jobs table and the alerts source — each card names the one that owns it',
    mode: 'Read-only orientation (R0). Quick actions are links to the screen that owns the action, never a write from Home.',
    screenType: 'workspace-tab',
    purpose:
      'Answer "is the platform healthy right now, and where is it drifting" in one screen, with every number attributable to the service that produced it.',
    primaryControl:
      'Refresh refetches every card; Quick actions navigate to the owning screen; the staleness banner appears only when the drift service reports real drift.',
    helpId: 'HLP-ROUTE-HOME-OVERVIEW',
    evidence: 'Redesign document Mockup 1 (image2.png); live-data tests in PlatformOverview.test.tsx',
    routePattern: '/home',
    routeQuery: '',
  },
];
